import toast from "react-hot-toast"
import { apiConnector } from "../apiconnector"
import { adminEndpoints, categories } from "../apis"

const {
  ADMIN_DASHBOARD_API,
  CREATE_CATEGORY_API,
  UPDATE_CATEGORY_API,
  DELETE_CATEGORY_API,
} = adminEndpoints

//Platform wide counts for the admin overview page
export const getAdminDashboard = async (token) => {
  let result = null

  try {
    const response = await apiConnector("GET", ADMIN_DASHBOARD_API, null, {
      Authorization: `Bearer ${token}`,
    })

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    result = response.data.data
  } catch (error) {
    console.log("ADMIN DASHBOARD API ERROR....", error)
    toast.error(error.response?.data?.message || "Could not fetch admin data")
  }

  return result
}

//The category list itself is public, so this reuses the existing endpoint
//rather than adding an admin only duplicate of it
export const fetchCategories = async () => {
  let result = []

  try {
    const response = await apiConnector("GET", categories.CATEGORIES_API)

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    result = response.data.data
  } catch (error) {
    console.log("FETCH CATEGORIES API ERROR....", error)
    toast.error(error.response?.data?.message || "Could not fetch categories")
  }

  return result
}

export const createCategory = async (data, token) => {
  const toastId = toast.loading("Creating category...")
  let success = false

  try {
    const response = await apiConnector("POST", CREATE_CATEGORY_API, data, {
      Authorization: `Bearer ${token}`,
    })

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    toast.success("Category created")
    success = true
  } catch (error) {
    console.log("CREATE CATEGORY API ERROR....", error)
    toast.error(error.response?.data?.message || "Could not create category")
  }

  toast.dismiss(toastId)
  return success
}

export const updateCategory = async (data, token) => {
  const toastId = toast.loading("Updating category...")
  let success = false

  try {
    const response = await apiConnector("POST", UPDATE_CATEGORY_API, data, {
      Authorization: `Bearer ${token}`,
    })

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    toast.success("Category updated")
    success = true
  } catch (error) {
    console.log("UPDATE CATEGORY API ERROR....", error)
    toast.error(error.response?.data?.message || "Could not update category")
  }

  toast.dismiss(toastId)
  return success
}

export const deleteCategory = async (data, token) => {
  const toastId = toast.loading("Deleting category...")
  let success = false

  try {
    const response = await apiConnector("DELETE", DELETE_CATEGORY_API, data, {
      Authorization: `Bearer ${token}`,
    })

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    toast.success("Category deleted")
    success = true
  } catch (error) {
    console.log("DELETE CATEGORY API ERROR....", error)
    //The server refuses to delete a category that still has courses, and that
    //message is the useful one to show, so it is surfaced as is
    toast.error(error.response?.data?.message || "Could not delete category")
  }

  toast.dismiss(toastId)
  return success
}
